import React from "react";
import PropTypes from 'prop-types';
import BrandfolderLogoHoriz from '@assets/images/Brandfolder_logo.png';
import UploadArea from '@components/common/filestack_uploader/upload_area';
import GuestUploadUppy from '@components/common/uppy/guest_upload_uppy';
import Footer from '@components/common/footer/main';
import Asset from '@helpers/asset';
import FileList from './file_list';

import "./styles/guest_upload";

class GuestUpload extends React.Component {
  state = {
    uploading: false,
    success: false,
    files: [],
    email: "",
    description: "",
    upload_prompt: ""
  };

  componentDidMount() {
    this.getUploadLink();
  }

  getUploadLink() {
    $.ajax({
      url: `/api/v4/upload_links/${this.props.upload_link_key}`,
      type: "GET",
      context: this,
      success: (response) => {
        const upload_prompt = response.data.attributes.description;
        this.setState({ upload_prompt });
      },
      error: () => {
        this.setState({ success: false, error: true, files: [] });
      }
    });
  }

  addFiles = (files) => {
    this.setState((prevState) => ({ files: [...prevState.files, ...files] }));
  }

  removeFile = (index) => {
    this.setState((prevState) => {
      prevState.files.splice(index, 1);
      return ({ files: prevState.files });
    });
  }

  updateEmail = (event) => {
    this.setState({ email: event.target.value });
  }

  updateDescription = (event) => {
    this.setState({ description: event.target.value });
  }

  submitAssets = (e) => {
    e.preventDefault();
    if (this.state.uploading) { return; }
    this.uploadToBrandfolder();
  }

  resetForm = () => {
    this.setState({ success: false, error: false, files: [], description: "" });
  }

  uploadToBrandfolder() {
    this.setState({ uploading: true });
    const { upload_link_key } = this.props;
    const { files, email, description } = this.state;
    const asset_attributes = files.map((file) => {
      const { filename, url, external_id, size, folder_path, mimetype } = file;
      return {
        name: Asset.friendlyFilename(filename),
        data: { guest_upload_data: { email, description } },
        attachments: [{ url, filename, external_id, size, folder_path, mime_type: mimetype }]
      };
    });
    $.ajax({
      url: `/api/v4/upload_links/${upload_link_key}/assets`,
      type: "POST",
      context: this,
      data: JSON.stringify({ data: { attributes: asset_attributes } }),
      beforeSend(xhr) {
        xhr.setRequestHeader("Content-Type", "application/json");
      },
      success: () => {
        this.setState({ success: true, error: false, files: [] });
      },
      error: () => {
        this.setState({ success: false, error: true, files: [] });
      },
      complete: () => {
        this.setState({ uploading: false });
      }
    });
  }

  renderUploadArea() {
    const { upload_link_key } = this.props;
    if (BFG.hasFeature('uppy_uploader_features')) {
      return (
        <GuestUploadUppy
          uploadLinkKey={upload_link_key}
          appendFiles={this.addFiles}
        />
      );
    }
    return (
      <div className="guest-upload-box">
        <div className="filestack-container">
          <UploadArea
            uploadType="guest_upload"
            uniqDomElement={`guest-upload-area-${upload_link_key}`}
            options={{ maxFiles: 3000 }}
            appendFiles={this.addFiles}
          />
        </div>
      </div>
    );
  }

  renderUpload() {
    const { success, error, files, upload_prompt } = this.state;
    const { brandfolder_name } = this.props;
    if (success) {
      return (
        <div className="guest-upload-area">
          <h2 className="guest-upload-prompt">
            {t("Awesome, we've sent along your assets!")}
          </h2>
          <button
            className="button primary"
            type="submit"
            onClick={this.resetForm}
          >
            {t('SEND MORE')}
          </button>
        </div>
      );
    }
    if (error) {
      return (
        <div className="guest-upload-area">
          <h2 className="guest-upload-prompt">
            {t('It looks like there was a problem uploading your assets.')}
          </h2>
          <button
            className="button primary"
            type="submit"
            onClick={this.resetForm}
          >
            {t('TRY AGAIN')}
          </button>
        </div>
      );
    }
    if (files.length > 0) {
      return (
        <div className="guest-upload-area">
          <h2 className="guest-upload-prompt">
            {t('Upload an asset to')}
            <br />
            {`${brandfolder_name}'s Brandfolder`}
          </h2>
          <FileList files={files} removeFile={this.removeFile} />
          <div className="divider" />
          {this.renderUploadArea()}
          <form className="guest-upload-form" onSubmit={this.submitAssets}>
            <label className="bf-label">
              {t('Email Address')}
              <input
                className="guest-upload-email-input input"
                type="email"
                value={this.state.email}
                placeholder="david.bowie@example.com"
                inputMode="email"
                onChange={this.updateEmail}
                required
              />
            </label>
            <label className="bf-label">
              {t('Message (optional)')}
              <textarea
                className="guest-upload-description-input textarea"
                value={this.state.description}
                placeholder="A description of the asset(s) you're uploading"
                maxLength={140}
                rows={3}
                onChange={this.updateDescription}
              />
            </label>
            <button
              className="button primary"
              type="submit"
            >
              {t('Submit')}
            </button>
          </form>
        </div>
      );
    }
    return (
      <div className="guest-upload-area">
        <h2 className="guest-upload-prompt">
          {t('Upload an asset to')}
          <br />
          {`${brandfolder_name}'s Brandfolder`}
        </h2>
        <p>{upload_prompt}</p>
        {this.renderUploadArea()}
      </div>
    );
  }

  render() {
    const { organization_logo } = this.props;
    return (
      <div className="guest-upload-component">
        <div className="guest-upload-header">
          <a href="https://brandfolder.com">
            <img
              className="brandfolder-logo"
              src={organization_logo}
              alt="brandfolder logo"
            />
          </a>
          <a
            className="bf-logo-container"
            href="https://brandfolder.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{t('Powered by')}</span>
            <img className="bf-logo-horiz" src={BrandfolderLogoHoriz} alt="branfolder logo" />
          </a>
        </div>
        <div className="guest-upload-body">
          { this.renderUpload() }
          <div className="guest-upload-brandfolder-description">
            <h3>{t('What is Brandfolder?')}</h3>
            <p>{t("Store, share, and showcase your assets in one place with Brandfolder, the world's most powerfully simple digital asset management software.")}</p>
            <a href="https://brandfolder.com" target="_blank" rel="noopener noreferrer" className="learn-more-link">{t('Learn More')}</a>
          </div>
          <img
            className="mast-image"
            src="https://cdn.brandfolder.io/XW2XTJEO/as/p7r990-60lotk-50ir0a/orig.png?width=500"
            alt="Brandfolder mock"
          />
        </div>
        <Footer whitelabeled />
      </div>
    );
  }
}

GuestUpload.propTypes = {
  upload_link_key: PropTypes.string.isRequired,
  brandfolder_name: PropTypes.string,
  organization_logo: PropTypes.string
};

GuestUpload.defaultProps = {
  brandfolder_name: "Brandfolder",
  organization_logo: ""
};


export default GuestUpload;
